<template lang="jade">
  div.Form(":skin"="skins.form")
    div.Form__wrapper
      fieldset.Fieldset
        div.Fieldset__body
          component(v-for="input in schema.props"
                    ":is"="input.type"
                    ":fdata"="input")
          stripe-input(v-for="input in fields"
                      ":type"="input.type"
                      ":attr.sync"="input"
                      ":elements"="content.elements")
  div.Button-group
      component(v-for="btn in content.buttons"
                ":is"="btn.type"
                ":fdata"="btn")             
</template>

<script>
  import _ from 'lodash'
  import stripeInput from './element'
  import { skins, forms, workflow } from 'src/vuex/getters'
  import { updateForm, addForm, setFormData } from 'src/vuex/actions.js'
  import schema from '../_data/stripe'

  export default {
    data () {
      return {
        schema,
        uid: this.$parent.uid,
        stripe: this.content.stripe,
        complete: false,
        fields: ['cardNumber', 'cardExpiry', 'cardCvc']
      }
    },
    props: {
      'content': {
        type: Object,
        coerce: x => {
          let data = _.first(x)
          let {buttons} = data
          let stripe = Stripe(data.stripePublishableKey)
          let elements = stripe.elements()
          return {data, stripe, elements, buttons}
        },
        required: true
      }
    },
    computed: {
      index () {
        return _.findIndex(this.forms, ['uid', this.uid])
      }
    },
    vuex: {
      getters: { skins, forms, workflow },
      actions: { updateForm, addForm, setFormData }
    },
    components: {
      stripeInput
    },
    methods: {
      setForm () {
        let btns = this.content.buttons.map(this.setButtons)
        this.addForm({
          uid: this.uid,
          workflow: this.uid,
          form: {fields: [{content: btns}], meta: this.workflow},
          siteid: ''
        })
      },
      setButtons (x) {
        let isTypeSubmit = _.eq(_.head(x.actions), 'submit')
        return isTypeSubmit ? _.set(x, 'actions', ['stripe']) : x
      },
      stripeInputs (inputs) {
        return _.map(inputs, xs => {
          let type = xs
          return {
            type,
            error: false,
            complete: false,
            empty: true,
            brand: '',
            value: undefined,
            element: undefined
          }
        })
      }
    },
    events: {
      // collect data from form fields
      'fdata::input' (input) {
        this.setFormData(input, this.index)
      }
    },
    created () {
      this.$set('fields', this.stripeInputs(this.fields))
      this.setForm()
    }
  }
</script>



// WEBPACK FOOTER //
// stripe.vue?68bbb5b6